import { ProductAddress } from '~/components/core/product/adapters/product-types';
import { QuoteAddress } from './types/basket-types';

export function formatAddress(address: QuoteAddress | ProductAddress) {
  const parts = [
    'contactname' in address ? address.contactname : address.contactName,
    `${address.property} ${address.street}`,
    address.town,
    address.postcode,
    typeof address.country === 'string' ? address.country : address.country.name
  ];
  return parts.filter(Boolean).join(', ');
}
